import React from 'react';

import { CategorizerHeadingRowGroup } from 'components';
import { AsyncFreeBetCategorizer } from 'modules/freebet/async';
import promo from 'modules/promo';
import CategorizerHeadingFavorite from '../CategorizerHeadingFavorite';

import './categorizerHeading.scss';

const {
    components: { FeaturedTournamentsList },
} = promo;

const CategorizerHeading: React.FC = () => {
    return (
        <div styleName="container">
            <AsyncFreeBetCategorizer />

            <CategorizerHeadingRowGroup>
                <CategorizerHeadingFavorite />
            </CategorizerHeadingRowGroup>

            <CategorizerHeadingRowGroup>
                <FeaturedTournamentsList />
            </CategorizerHeadingRowGroup>
        </div>
    );
};

export default CategorizerHeading;
